import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.object.assign";
import _typeof from "D:\\vue_workspace\\vue_kw_plat\\node_modules\\@babel\\runtime/helpers/esm/typeof";
import pageUtils from '@/js/page/pageUtil.js';
import wx from 'weixin-js-sdk';
var utils = {
  isNull: function isNull(ele) {
    if (ele == null || ele == undefined || ele == "null" || ele == "" || ele == "undefined") {
      return true;
    } else {
      return false;
    }
  },
  isNotNull: function isNotNull(ele) {
    return !this.isNull(ele);
  },

  /**
   * 封装后台请求的request方法
   * @param {url,toHtData,success} json 
   */
  request: function request(that, json) {
    // 追加需要传递到后台的参数 json.toHtData
    if (json.url.indexOf("/") != 0) {
      json.url = "/" + json.url;
    } // json.url = "/kw_plat"+json.url;


    if (json.data) {
      if (!json.data.sourceType) {
        // 追加访问请求的参数
        json.data.sourceType = this.checkVisitSource();
      }
    }

    var objSceneJson = json.data && _typeof(json.data) == 'object' ? json.data.auto_append_json : null; // 增加需要传递到后台的参数 
    // 扫码携带的参数
    // 把项目ID传递到后台  

    var login_proId = "";

    if (utils.isNotNull(localStorage.loginInfo)) {
      var loginInfo = JSON.parse(localStorage.loginInfo);
      login_proId = loginInfo.login_proId;
    }

    if (utils.isNotNull(localStorage.sceneJson)) {
      var sceneJson = JSON.parse(localStorage.sceneJson); // 转发打开 携带的参数

      if (sceneJson) {
        Object.assign(json.data, sceneJson);
        sceneJson.proId = login_proId;

        if (objSceneJson) {
          sceneJson = Object.assign(objSceneJson, sceneJson);
        }

        if (_typeof(sceneJson) == 'object') {
          json.data.json = JSON.stringify(sceneJson);
        } else {
          json.data.json = sceneJson;
        }
      }
    } else {
      var noSceneJson = {};
      noSceneJson.shamOpenId = pageUtils.getShamOpenId();
      noSceneJson.proId = login_proId;

      if (objSceneJson) {
        if (_typeof(objSceneJson) == 'object') {
          noSceneJson = Object.assign(objSceneJson, noSceneJson);
        }
      }

      json.data.json = JSON.stringify(noSceneJson);
    }

    if (login_proId != "") {
      json.data.proId = login_proId;
    } // saas的客户域名判断


    if (localStorage.domain_name) {
      json.data.domain_name = localStorage.domain_name;
    }

    that.$axios.post(json.url, json.data).then(function (res) {
      if (res.data == "未登陆,请先登陆") {
        if (json.noLoginFun) {
          json.noLoginFun(res);
        } // 如果未登录 进行打开登录页面的操作


        if (that.$router.app.$children[0].openLogin) {
          that.$router.app.$children[0].openLogin(json);
        }
      } else {
        json.success(res);
      }
    }).catch(function (error) {
      console.log("error========", error);

      if (json.error) {
        json.error(error);
      }
    });
  },

  /**
   * 去后台进行登陆的方法
   */
  toHtLoginIn: function toHtLoginIn(userName, password, that, callBackJson, afterJosn) {
    var toHtData = {};
    toHtData.loginName = userName;
    toHtData.password = password; //进行登陆验证

    this.toHtLoginRequest(toHtData, that, callBackJson, afterJosn);
  },

  /**
   * 验证码登录
   */
  yzmToHtLoginIn: function yzmToHtLoginIn(userName, yzmCode, that, registerId) {
    var toHtData = {};
    toHtData.loginName = userName;
    toHtData.sjNum = yzmCode;
    toHtData.registerId = registerId; //进行登陆验证

    this.toHtLoginRequest(toHtData, that);
  },
  toHtLoginRequest: function toHtLoginRequest(toHtData, that, callBackJson, afterJosn) {
    var utils = this; // that.fullscreenLoading = true;
    //项目id 从localStorage中获取proId
    // if(utils.isNotNull(localStorage.proId)) {
    //     var proId = localStorage.proId;
    //     toHtData.proId = proId;
    // } else {

    if (localStorage.domain_name && localStorage.domain_name != "" && that.GLOBAL.proIdJson[localStorage.domain_name]) {
      toHtData.proId = that.GLOBAL.proIdJson[localStorage.domain_name];
    } else {
      toHtData.proId = that.GLOBAL.proId;
    } // }


    var cientType = pageUtils.getCientType();

    if (cientType != "") {
      var openId = localStorage.openId;
      var unionId = localStorage.unionId;

      if (utils.isNotNull(openId)) {
        if (cientType == "miniprogram") {
          toHtData.xcxOpenId = openId;
        } else {
          toHtData.gzhOpenId = openId;
        }
      }

      if (utils.isNotNull(unionId)) {
        toHtData.unionId = unionId;
      }
    }

    var loading = null;

    if (that.ifChild == 1) {
      loading = that.$loading({
        lock: true,
        text: '登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    } //判断是否需要区分H5权限


    var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");

    if (programaSetInfo) {
      programaSetInfo = JSON.parse(programaSetInfo);
      console.log("that.visitSource======================", that.visitSource, programaSetInfo.ZD_IF_H5_ROLE);

      if (that.visitSource == 3 && programaSetInfo.ZD_IF_H5_ROLE == 1) {
        toHtData.mobileShow = 1;
      }
    } else if (that.visitSource == 3) {
      toHtData.mobileShow = 1;
    }

    var url = "/login_interfaceLogin.do";
    this.request(that, {
      url: url,
      data: toHtData,
      success: function success(res) {
        // 暂时登录成功后 返回首页
        if (loading != null) {
          loading.close();
        } // 登录按钮 放置重复点击
        // that.fullscreenLoading = false;
        // that.ifLoad = true;


        if (res.data.error == 0) {
          // 登录成功之后把登录的用户名 放置到cookie中
          pageUtils.setCookie("vueLoginUserName", toHtData.loginName, 1);

          try {
            setVueLoginUserNameFlutter.postMessage(toHtData.loginName);
          } catch (error) {}

          utils.loginSuccessAfter(res.data, that);
        } else {
          if ("未注册,请先注册" == res.data.errorMsg) {
            var registerJson = {
              stuName: '',
              stuPhone: toHtData.loginName,
              passWord1: '111111',
              passWord2: '111111'
            }; // var sceneJson = app.globalData.sceneJson;
            // if (sceneJson) {
            //   for (var key in sceneJson) {
            //     registerJson[key] = sceneJson[key];
            //   }
            // }

            utils.toHtSaveRegister(registerJson);
          } else {
            //登陆失败
            that.$message({
              showClose: true,
              message: res.data.errorMsg,
              type: 'error'
            });
          }
        }

        if (afterJosn && afterJosn.loginType == 99 && callBackJson) {
          callBackJson();
        }
      }
    });
  },
  loginSuccessAfter: function loginSuccessAfter(resData, that) {
    localStorage.sessionId = resData.loginInfo.sessionId;
    console.log("localStorage.sessionId==================================", localStorage.sessionId); //登陆人的账户信息

    localStorage.loginInfo = JSON.stringify(resData.loginInfo);
    localStorage.USERID = resData.loginInfo.USERID; //登陆人的栏目列表信息

    localStorage.menuList = JSON.stringify(resData.menuList); //登陆人的session信息

    localStorage.sessionMap = JSON.stringify(resData.sessionMap); //登录人的按钮权限信息

    localStorage.user_buttons = resData.buttons;
    var ecshopSysSet = resData.ecshopSysSet;
    localStorage.ecshopSysSet = JSON.stringify(ecshopSysSet); //登录的项目表的设置信息

    var programaSetInfo = resData.programaSetInfo;

    if (programaSetInfo) {
      pageUtils.setSessionParam("programaSetInfo", JSON.stringify(programaSetInfo));
    }

    if (resData.homeMenuList && resData.homeMenuList.length > 0) {
      pageUtils.setHomeMenuList(JSON.stringify(resData.homeMenuList));

      if (that.initShamInfo) {
        that.initShamInfo(that);
      }
    }

    var loginInfo = resData.loginInfo; // 判断刷新首页的 状态

    if (that.$router.app.$children[0]) {
      var nowPage = that.$router.app.$children[0].$children[0];
      console.log("nowPage=============================", nowPage);

      if (nowPage && nowPage.initShamInfo) {
        nowPage.initShamInfo(nowPage);
      }

      if (that.visitSource == 3 && nowPage && nowPage.menuHandleClick) {
        nowPage.menuHandleClick("0");
      }
    } // 判断是否是留学客户 如果是留学客户则需要进行 首页的按钮的显示和隐藏调整


    var nowPage = that.$router.app.$children[0].$children[0];

    if (nowPage && nowPage.$refs.header) {
      nowPage.$refs.header.initLoginInfo();
    }

    if (that.ifChild == 1) {
      // that.$parent.closeMaskOrLogin();
      that.$emit("closeMaskOrLogin");
    } else if (that.ifChild == 0) {
      //判断客户端
      var flag = utils.checkVisitSource();
      var toPageName = "MainPage"; // if(flag){
      //     toPageName = "MailHome";
      // }

      that.$router.push({
        name: toPageName,
        params: {}
      }); // window.history.length > 1
      // ? this.$router.go(-1)
      // : this.$router.push({ 
      //     name: toPageName, 
      //     params: {
      // }});
    }
  },

  /**
   * 去后台的注册功能
   */
  toHtSaveRegister: function toHtSaveRegister(that, formJson) {
    var utils = this; //注册成功

    var toHtData = formJson;
    var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");
    console.log("programaSetInfo===================", programaSetInfo);

    if (programaSetInfo) {
      programaSetInfo = JSON.parse(programaSetInfo);
      toHtData.tableId = programaSetInfo.REGISTER_TABLE_ID;
      toHtData.pageId = programaSetInfo.REGISTER_PAGE_ID;
    } else {
      toHtData.tableId = 448;
      toHtData.pageId = 13081;
    }

    toHtData.isInterFace = 1;
    toHtData.stuOrg = 1;
    toHtData.stuOrg_ID = 2;
    toHtData.stuSchool = 1;
    toHtData.stuSchool_ID = 1;
    toHtData.ifQz = 176;
    toHtData.ifStu = 177;
    toHtData.casting = 1;
    toHtData.casting_ID = 6;
    toHtData.sourceOne = 5;
    toHtData.source = 1;
    var loading = that.$loading({
      lock: true,
      text: '注册中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    }); //进行登陆验证

    this.request(that, {
      url: 'add_addInfo.do',
      //仅为示例，并非真实的接口地址
      data: toHtData,
      success: function success(res) {
        loading.close();

        if (res.data > 0) {
          //注册成功 自动登录
          that.$message({
            message: '注册成功,自动登录中!',
            type: 'success'
          });
          utils.toHtLoginIn(toHtData.stuPhone, toHtData.passWord1, that);
        } else {
          //登陆失败 提示
          that.$message({
            message: '注册失败!此手机号已注册过!',
            type: 'error'
          });
        }
      },
      fail: function fail() {
        loading.close();
        that.$message({
          message: '注册出现问题,请重试或者联系管理员!',
          type: 'error'
        });
      }
    });
  },

  /**
   * 退出登录的方法
   */
  loginOut: function loginOut(that) {
    this.loginOutClearSession(); // 清除自动登录的相关信息

    pageUtils.setCookie("vueAutoLoginUserName", '', 1);
    pageUtils.setCookie("vueLoginUserName", '', 1);

    try {
      setVueLoginUserNameFlutter.postMessage("");
    } catch (error) {}

    var toHtData = {};
    var openId = localStorage.openId;
    var unionId = localStorage.unionId;
    var cientType = pageUtils.getCientType();

    if (utils.isNotNull(openId)) {
      if (cientType == "miniprogram") {
        toHtData.xcxOpenId = openId;
      } else {
        toHtData.gzhOpenId = openId;
      }
    }

    this.request(that, {
      url: '/login_outAjax.do',
      //仅为示例，并非真实的接口地址
      data: toHtData,
      success: function success(res) {
        var msg = "";

        if (res.data == 1) {
          msg = "退出登陆成功"; // location.reload();
        } else {
          msg = "退出登陆失败";
        } //登陆失败


        that.$message({
          showClose: true,
          message: msg,
          type: 'success'
        }); // pageUtils.toMailHome(that);
        // that.$router.go(0);
      }
    }); // 判断刷新首页的 状态

    if (that.$router.app.$children[0]) {
      var nowPage = that.$router.app.$children[0].$children[0];

      if (nowPage && nowPage.initShamInfo) {
        //nowPage.initShamInfo(nowPage);
        //刷新页面
        that.$router.go(0);
      } else if (nowPage && nowPage.$refs.header) {
        nowPage.$refs.header.initLoginInfo();
      } else {
        var domain_name = localStorage.domain_name;
        var loginPath = 'loginPage' + (domain_name ? "/" + domain_name : "");
        that.$router.push({
          path: loginPath
        });
      }
    }
  },
  loginOutClearSession: function loginOutClearSession() {
    //登陆人的账户信息
    localStorage.loginInfo = null;
    localStorage.USERID = null; //登陆人的栏目列表信息

    localStorage.menuList = null; //登陆人的session信息

    localStorage.sessionMap = null; //登录人的按钮权限信息

    localStorage.user_buttons = null;
    localStorage.ifLx = "false"; // pageUtils.setShamOpenId("");
  },

  /**
   * 数据字典默认选中
   */
  dicDefaultCheck: function dicDefaultCheck(oneField, dicId) {
    oneField.defaultCheckValue = dicId;
    var dicName = "";
    var dicList = oneField.dicList;
    var checkIndexArr = [];
    var checkValueIndex = "";

    for (var j = 0; j < dicList.length; j++) {
      dicList[j].CHECKED = false;

      if (("," + oneField.defaultCheckValue + ",").indexOf("," + dicList[j].DIC_ID + ",") >= 0) {
        dicList[j].CHECKED = true;
        checkIndexArr.push(j);

        if (dicName != "") {
          dicName += ",";
          checkValueIndex += ",";
        }

        dicName += dicList[j].DIC_NAME;
        checkValueIndex += j;
      }
    }

    oneField.defaultCheckCnName = dicName;
    oneField.defaultCheckIndexArr = checkIndexArr;
    oneField.defaultCheckValueIndex = checkValueIndex;
  },

  /**
   * 获取虚拟登录的主键信息
   */
  getShamLoginId: function getShamLoginId(that, callback) {
    // 获取缓存的主键信息
    var WEB_OPENID = localStorage.openId;
    var VISIT_SOURCE = that.visitSource;
    var domain_name = localStorage.domain_name;
    var toHtData = {
      WEB_OPENID: WEB_OPENID,
      VISIT_SOURCE: VISIT_SOURCE,
      domain_name: domain_name,
      source: 1
    };
    this.request(that, {
      url: '/wxXcxSet_getShamLoginInfo.do',
      //仅为示例，并非真实的接口地址
      data: toHtData,
      success: function success(res) {
        var result = res.data;

        if (result) {
          // && result.length > 0
          // var openIdArr = result.split("&");
          localStorage.openId = result.WEB_OPENID;
          pageUtils.setShamOpenId(result.shamOpenId);

          if (result.homeMenuList && result.homeMenuList.length > 0) {
            pageUtils.setHomeMenuList(JSON.stringify(result.homeMenuList));
          } else {
            pageUtils.setHomeMenuList("");
          }

          if (result.programaSetInfo) {
            pageUtils.setSessionParam("programaSetInfo", JSON.stringify(result.programaSetInfo));
          }

          that.ifLoad = true;
        }

        if (callback) {
          callback(that);
        }
      }
    });
  },

  /**
   * 获取微信code
   */
  getWxCode: function getWxCode(that) {
    var appId = that.GLOBAL.app_id[0];
    var redirect_uri = window.location.href;
    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
    window.location.href = url;
  },

  /**
   * 获取用户的微信的openId
   */
  getWxOpenId: function getWxOpenId(that, code, callback) {
    var utils = this;
    var appId = that.GLOBAL.app_id[0];
    var secret = that.GLOBAL.app_secret[0]; //根据pageId获取列表页面的设置信息 获取列表页面的数据信息

    utils.request(that, {
      url: "wxXcxSet_getOpenId.do?source=99",
      //仅为示例，并非真实的接口地址
      data: {
        js_code: code,
        appid: appId,
        secret: secret,
        visitSource: 3
      },
      success: function success(res) {
        var result = res.data;

        if (result) {
          // && result.length > 0
          // var openIdArr = result.split("&");
          localStorage.openId = result.openId; //openIdArr[0];

          localStorage.unionId = result.nuionId; //openIdArr[1];

          pageUtils.setShamOpenId(result.shamOpenId); //openIdArr[2];

          if (result.homeMenuList && result.homeMenuList.length > 0) {
            pageUtils.setHomeMenuList(JSON.stringify(result.homeMenuList));
          } else {
            pageUtils.setHomeMenuList("");
          }

          if (result.programaSetInfo) {
            pageUtils.setSessionParam("programaSetInfo", JSON.stringify(result.programaSetInfo));
          }

          utils.toHtLoginIn("", "", that, null, null);
          that.ifLoad = true;
        }

        if (callback) {
          callback(that);
        }
      }
    });
  },

  /**
   * 打开文件
   */
  openFile: function openFile(that, fileSrc) {
    var src = that.GLOBAL.getFileServeUrl() + fileSrc; // window.location.href = src;

    window.open(src);
  },

  /**
   * 检查用户的浏览器来源是否是手机浏览器
   */
  checkVisitSource: function checkVisitSource(that) {
    var visitSource = 2;

    if (that && that.previewVisitSource > 0) {
      visitSource = that.previewVisitSource;
    } else {
      //判断客户端
      var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

      if (flag) {
        //移动端
        visitSource = 3;
        localStorage.setItem('visitSource', 3);
      } else {
        //PC
        visitSource = 2;
        localStorage.setItem('visitSource', 2);
      }
    }

    return visitSource;
  },

  /**
   * 根据 字段下标 获取字段对应的设置信息
   */
  getFieldSetByIndex: function getFieldSetByIndex(fieldSet, strIndex) {
    strIndex = strIndex + "";

    if (strIndex.indexOf("-") >= 0) {
      var strIndexArr = strIndex.split(":");
      var tmpFieldSet = fieldSet; //循环

      for (var i = 0; i < strIndexArr.length; i++) {
        var nowInfo = strIndexArr[i];

        if (nowInfo != "") {
          var nowInfoArr = nowInfo.split("-");
          var nowFieldIndex = nowInfoArr[0];
          var nowDataIndex = nowInfoArr[1];

          if (nowDataIndex != "") {
            tmpFieldSet = tmpFieldSet.childPageJsonArr[nowDataIndex];
            tmpFieldSet = tmpFieldSet.fieldSet[nowFieldIndex];
          } else {
            tmpFieldSet = tmpFieldSet[nowFieldIndex];
          }
        }
      }

      return tmpFieldSet;
    } else {
      return fieldSet[strIndex];
    }
  },

  /**
   * 初始化微信分享组件
   */
  initWxShare: function initWxShare(that) {
    if (pageUtils.isWeixinCient()) {
      var url = "wxXcxSet_getJsapiConfig.do?source=1";
      var toHtData = {};
      var agent = navigator.userAgent;
      var isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

      if (isiOS) {
        // toHtData.url = "https://study.bailiedu.com/vue_kw_plat/mailHome";
        toHtData.url = localStorage.getItem('originUrl');
      } else {
        toHtData.url = window.location.href.split("#")[0];
      }

      utils.request(that, {
        url: url,
        //仅为示例，并非真实的接口地址
        data: toHtData,
        success: function success(res) {
          var configJson = res.data;
          var title = "百利天下教育";
          var desc = "百利天下教育";
          var linkurl = window.location.href;
          var scene = "";
          var pageRouteInfo = pageUtils.getShareRouteInfo(that);
          scene = pageRouteInfo.scene;

          if (scene != "") {
            linkurl += "&scene=" + scene;
          }

          var imgUrl = 'http://bailitianxia-edus.oss-cn-beijing.aliyuncs.com/2020-05-10/%E5%95%86%E5%9F%8E%E9%BB%98%E8%AE%A4%E5%9B%BE%E7%89%87.png';
          wx.config({
            debug: false,
            // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: that.GLOBAL.app_id[0],
            // 必填，公众号的唯一标识
            timestamp: configJson.timestamp,
            // 必填，生成签名的时间戳
            nonceStr: configJson.noncestr,
            // 必填，生成签名的随机串
            signature: configJson.signature,
            // 必填，签名
            jsApiList: ['showOptionMenu', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表

          });
          wx.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            wx.showOptionMenu();
            wx.updateAppMessageShareData({
              title: title,
              desc: desc,
              link: linkurl,
              imgUrl: imgUrl,
              trigger: function trigger(res) {},
              success: function success(res) {
                console.log('已分享');
              },
              cancel: function cancel(res) {
                console.log('已取消');
              },
              fail: function fail(res) {//   alert(JSON.stringify(res));
              }
            });
            wx.updateTimelineShareData({
              title: title,
              desc: desc,
              link: linkurl,
              imgUrl: imgUrl,
              trigger: function trigger(res) {},
              success: function success(res) {
                console.log('已分享');
              },
              cancel: function cancel(res) {
                console.log('已取消');
              },
              fail: function fail(res) {//   alert(JSON.stringify(res));
              }
            });
          });
          wx.error(function (res) {// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            //   alert("error===" + JSON.stringify(res));
          });
        }
      });
    }
  },

  /*
   * 对数字进行加密
   */
  kwBtoa: function kwBtoa(value) {
    var json = {
      "a_0": "z",
      "a_1": "k",
      "a_2": "q",
      "a_3": "p",
      "a_4": "m",
      "a_5": "g",
      "a_6": "c",
      "a_7": "t",
      "a_8": "o",
      "a_9": "f"
    };
    var result = "";
    var valueArr = value.split("");

    for (var i = 0; i < valueArr.length; i++) {
      result += isNaN(valueArr[i]) ? valueArr[i] : json["a_" + valueArr[i]];
    }

    return result;
  },

  /**
   * 对数字进行解密
   */
  kwAtob: function kwAtob(value) {
    var json = {
      "z": "0",
      "k": "1",
      "q": "2",
      "p": "3",
      "m": "4",
      "g": "5",
      "c": "6",
      "t": "7",
      "o": "8",
      "f": "9"
    };
    var result = "";
    var valueArr = value.split("");

    for (var i = 0; i < valueArr.length; i++) {
      result += json[valueArr[i]] ? json[valueArr[i]] : valueArr[i];
    }

    return result;
  },
  IdCardGetInfo: function IdCardGetInfo(UUserCard, num) {
    if (UUserCard.length >= 18) {
      if (num == 1) {
        //获取出生日期
        var birth = UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
        return birth;
      }

      if (num == 2) {
        //获取性别
        if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
          //男
          return 1;
        } else {
          //女
          return 2;
        }
      }

      if (num == 3) {
        //获取年龄
        var myDate = new Date();
        var month = myDate.getMonth() + 1;
        var day = myDate.getDate();
        var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;

        if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
          age++;
        }

        return age;
      }
    }
  }
};
export default utils;